/**
 * The pills above the tasting boxes: each shows the boxes of one kind and
 * hides the rest; the first shows them all.
 */
class BoxFilter extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.addEventListener('click', this.#onClick, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #onClick = (event) => {
    const pill = event.target.closest('button[data-kind]');
    if (!pill) return;

    for (const other of this.querySelectorAll('button[data-kind]')) {
      const active = other === pill;
      other.classList.toggle('is-active', active);
      other.setAttribute('aria-pressed', String(active));
    }
    for (const card of this.querySelectorAll('.sda-box[data-kind]')) {
      card.hidden = pill.dataset.kind !== '' && card.dataset.kind !== pill.dataset.kind;
    }
  };
}

if (!customElements.get('box-filter')) customElements.define('box-filter', BoxFilter);
